<template>
  <div class="container">
    <h2 class="title">{{ title }}</h2>
    <ul class="content">
      <li
        v-for="(v, i) in contentList"
        :key="i"
        :class="{ blog: v.read }"
        @click="goDetail(v)"
      >
        <span class="blog-title" v-html="v.title"></span>
        <span class="read">阅读：{{ v.readPv }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    contentList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(["hasLogin", "token"]),
  },
  methods: {
    goDetail(e) {
      if (e.articleType === 0) {
        window.open(`${this.$global.SeoUrl}thesisDetail?type=0&id=${e.articleId}`);
      } else if (e.articleType === 6) {
        let routeUrl = this.$router.resolve({
          path: "/dataDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else if (e.articleType === 2) {
        let routeUrl = this.$router.resolve({
          path: "/concentrationDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else if (e.articleType === 5) {
        let routeUrl = this.$router.resolve({
          path: "/msgDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
  box-sizing: border-box;
  overflow: hidden;
  .title {
    height: 68px;
    padding: 26px 0 0 28px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #e5e5e5;
  }
  .content {
    padding: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    li {
      border-bottom: none;
      padding: 5px 0 25px 0;
      .blog-title {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; //行数
        -webkit-box-orient: vertical;
        cursor: pointer;
      }
      &:not(:last-child) {
        border-bottom: 1px dashed #e8e8e8;
      }
      .read {
        font-size: 12px;
        font-weight: 400;
        color: #c8c8c8;
        float: right;
        margin-top: 5px;
      }
    }
  }
}
</style>
